export const INVOICE_TYPE_CODE = {
  TAKE_AWAY: 1,
  DELIVERY: 3,
  DINE: 2,
};
